import { Popover } from '@headlessui/react';
import ChevronUp from 'svg/ChevronUp';
import Clock from 'svg/Clock';
import classNames from 'styles/utils/classNames';
import { TimeEnum } from '../enums';
import { timeOptions } from '../utils';

interface TimeDropdownProps {
  time: TimeEnum;
  setTime: React.Dispatch<React.SetStateAction<TimeEnum>>;
  wrapperClassName?: string;
}

const TimeDropdown: React.FC<TimeDropdownProps> = ({ time, setTime, wrapperClassName }) => {
  return (
    <Popover className={classNames('relative', wrapperClassName)}>
      {({ open, close }) => (
        <>
          {/*adding small margin to account for line height */}
          <Popover.Button className="typography-product-button-label-medium flex w-[8.75rem] items-center justify-between gap-2 bg-color-bg-input-lightmode-primary px-4 py-3 dark:bg-color-bg-darkmode-primary max-md:w-full md:rounded-full">
            <div className="flex items-center gap-2">
              <Clock className="h-5 w-5 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
              <span className="typography-product-button-label-medium max-sm:text-color-text-lightmode-placeholder max-sm:dark:text-color-text-darkmode-placeholder">
                {timeOptions.find((option) => option.value === time)?.label}
              </span>
            </div>
            <ChevronUp
              className={classNames(
                'h-4 w-4 shrink-0 rotate-180 transition-transform',
                open && '!rotate-0',
              )}
            />
          </Popover.Button>
          <Popover.Panel
            className={
              'absolute z-10 mt-2 w-full rounded-3xl border border-color-border-input-lightmode bg-color-bg-lightmode-primary p-ds-md shadow-lg dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary'
            }
          >
            <div className="flex flex-col gap-1">
              {timeOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => {
                    setTime(option.value);
                    close();
                  }}
                  className={classNames(
                    'typography-product-button-label-medium rounded-xl border border-transparent p-ds-md text-left text-color-text-lightmode-secondary transition-all hover:border-color-bg-lightmode-icon    dark:text-color-text-darkmode-secondary hover:dark:border-color-bg-darkmode-icon',
                    time === option.value &&
                      '!border-color-bg-lightmode-icon dark:!border-color-bg-darkmode-icon',
                  )}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
};

export default TimeDropdown;
